export enum AudienceType {
  AuthoredAudience = 'authored',
  GWIAudience = 'curated',
  InstantAudience = 'instant',
  SharedAudience = 'shared',
  Undefined = '' // Bug fix
}

export enum Feedback {
  ThumbsUp = 'thumbs-up',
  ThumbsDown = 'thumbs-down',
  None = 'none'
}

export enum Log {
  Custom = 'custom',
  Debug = 'debug',
  Info = 'info',
  Notice = 'notice',
  Warning = 'warning'
}

export enum MessageType {
  User = 'user',
  Loading = 'assistant_loading',
  NaturalLanguage = 'assistant_natural_language',
  ReplyEnd = 'assistant_reply_end',
  System = 'system',
  AgentThinking = 'agent_external_thinking'
}

export enum Metric {
  AudiencePercentage = 'audience_percentage',
  Universe = 'positive_size',
  Index = 'index'
}

export enum WindowSize {
  ExtraExtraLarge = 'xx-large',
  ExtraLarge = 'x-large',
  Large = 'large',
  Medium = 'medium',
  Small = 'small',
  ExtraSmall = 'x-small',
  ExtraExtraSmall = 'xx-small'
}
